import { render } from "./RegisterModel.vue?vue&type=template&id=11691b79"
import script from "./RegisterModel.vue?vue&type=script&lang=js"
export * from "./RegisterModel.vue?vue&type=script&lang=js"

import "./RegisterModel.vue?vue&type=style&index=0&id=11691b79&lang=css"

import exportComponent from "G:\\VUE\\waimao518_3.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__